import { Action, ActionReducer } from '@ngrx/store';

import * as actions from '../auth/auth.actions';

/**
 * MetaReducer that resets to initial state after logging out
 * @param next The next metareducer to apply
 */
export function logoutReducer(next: Function): ActionReducer<any> {
  return (state: any, action: Action): any => {
    switch (action.type) {
      case actions.ResponseSuccessAuthLogoutAction.type:
        // This takes advantage of the fact that reducers supply an initial state
        // if called without the state passed in as a param
        return next(undefined, action);
      default:
        return next(state, action);
    }
  };
}
